// Angular modules
import { HttpClient }         from '@angular/common/http';
import { HttpHeaders }        from '@angular/common/http';
import { Injectable }         from '@angular/core';

// External modules
import { Language }           from '../models/language';
import { Translation }        from '../models/translation';
import { ApplicationService } from './application-service';
import { Observable }         from 'rxjs/Rx';
import 'rxjs/add/operator/map';

// Internal modules
import { environment }        from '../../../environments/environment';

@Injectable()
export class LangService
{
  constructor(public http: HttpClient, public applicationService: ApplicationService)
  {

  }

  requestLanguages(): Promise<Language[]>
  {
    let headers    = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept' : 'application/json', 'apiKey' : environment.API_KEY });
    let options    = { headers: headers, withCredentials: true };

    return this.http.get<Language[]>(environment.API_ENDPOINT + '/languages', options)
    .catch((error:any) => Observable.throw(error.json().error))
    .toPromise();
  }

  requestLanguageById(languageId): Promise<Translation[]>
  {
    let headers    = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept' : 'application/json', 'apiKey' : environment.API_KEY });
    let options    = { headers: headers, withCredentials: true };

    return this.http.get<Translation>(environment.API_ENDPOINT + '/translations/'+ languageId, options)
    .catch((error:any) => Observable.throw(error.json().error))
    .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/lang-service.ts